import { Modal } from "react-bootstrap";
import "./BidOnCounty.css";
import { trackButtonClick } from "@/utils/analytics";

const BidOnCounty = ({ setShowBanner, showBanner, redirectUrl }) => {
  return (
    <Modal show={showBanner} onHide={() => setShowBanner(false)} closeButton size="xl">
      <Modal.Header closeButton className="birdsey-modal-header"></Modal.Header>
      <Modal.Body className="p50">
        <div class="county-bidding-terms">
          <div class="cb-head">You are being redirected to the county website</div>
          <div class="cb-desc">You will be taken to the county site that is managing this foreclosure sale. Once on the site, please follow the steps below.</div>
          <div class="cb-terms">
            <div class="term">
              <div class="term-no">
                <div>1</div>
              </div>
              <div class="term-label">
                <span>Register</span> for a new account or sign in to an existing account
              </div>
            </div>
            <div class="term">
              <div class="term-no">
                <div>2</div>
              </div>
              <div class="term-label">
                <span>Make a deposit</span> on the property before the sale’s scheduled start time
              </div>
            </div>
            <div class="term">
              <div class="term-no">
                <div>3</div>
              </div>
              <div class="term-label">
                <span>Place a bid</span> on the property
              </div>
            </div>
          </div>
          <div class="cb-btn">
              <a href={redirectUrl} target="_blank" title="Continue to the site" class="cb-continue"
              onClick={() => {
                trackButtonClick({
                  eventName: "continue_to_fc_county_website",
                  eventCategory: "NEW-PDP"
                })
              }}
              >Continue to the site</a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BidOnCounty;
